import React from "react";
import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";
import "./Footer.css";

import { Link } from "react-router-dom";

const footerQuickLinks = [
  {
    display: "Home",
    url: "",
  },
  {
    display: "About",
    url: "About",
  },

  {
    display: "Courses",
    url: "Courses",
  },
  {
    display: "Testimonials",
    url: "Testimonials",
  },
  {
    display: "Contact",
    url: "Contact",
  },
];

const footerInfoLinks = [
];

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col lg="3" md="6" className="mb-4">
            <h2 className=" d-flex align-items-center gap-1">
              <img className="Logo-footer" width='160' height='60' alt='logo' src={'/images/logos/Vajramudita-logo-blank-white-480x190.webp'}></img>
            </h2>

            <div className="follows">
              <p className="mb-0">Follow us on social media</p>
              <span>
                {" "}
                <a href="facebook.com">
                  <i className="ri-facebook-line"></i>
                </a>
              </span>

              <span>
                {" "}
                <a href="facebook.com">
                  <i className="ri-instagram-line"></i>
                </a>
              </span>

              <span>
                {" "}
                <a href="facebook.com">
                  <i className="ri-linkedin-line"></i>
                </a>
              </span>

              <span>
                {" "}
                <a href="facebook.com">
                  <i className="ri-twitter-line"></i>
                </a>
              </span>
            </div>
          </Col>

          <Col lg="3" md="6" className="mb-4" id="Network">
            <h6 className="fw-bold">My Network</h6>
            <ListGroup className="link__list">
              {footerInfoLinks.map((item, index) => (
                <ListGroupItem key={index} className="border-0 ps-0 link__item">
                  {" "}
                  <a href={item.url}>{item.display}</a>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>

          <Col lg="3" md="6" className="mb-4">
            <h6 className="fw-bold">Explore</h6>
            <ListGroup className="link__list">
              {footerQuickLinks.map((item, index) => (
                <ListGroupItem key={index} className="border-0 ps-0 link__item">
                  {" "}
                  <Link to={item.url}>{item.display}</Link>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>


          <Col lg="3" md="6">
            <h6 className="fw-bold">Get in Touch</h6>

            <p>Address: Knutsford, Cheshire</p>
            <p> Phone: +(44) 7986130368 </p>
            <a href='mailto:vajramudita@gmail.com'>Email: vajramudita@gmail.com</a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;